import script from "./navigationPage.vue?vue&type=script&lang=js"
export * from "./navigationPage.vue?vue&type=script&lang=js"

import "./navigationPage.vue?vue&type=style&index=0&id=0c5ef434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5ef434"]])

export default __exports__